module.exports = __webpack_public_path__ + "img/file-word-solid.4167cdbc.svg";